export default __webpack_public_path__ + "static/media/discardbox_open.0d374225.png";